import { useState, useEffect } from 'react'
import { gql } from '@apollo/client'
import { PENDING_BY_REPORT_QUERY } from '../../../graphql.js'
import { Alert, Table } from 'reactstrap'
import Spinner from '../../Spinner/Spinner.js'
import '../Custom.css'
import { getData } from '../CustomUtils.js'
import ColumnHeadings from '../ColumnHeadings.js'
import ParameterValues from '../ParameterValues.js'
import ReportGrid from '../ReportGrid.js'
import { getTenant } from '../../../utils.js'
import LargeRowHandler from '../LargeRowHandler.js'
import ReportHeading from '../ReportHeading.js'
import ReportTotalsRow from '../ReportTotalsRow.js'

const PENDING_BY_REPORT = gql(PENDING_BY_REPORT_QUERY)

export default function PendingByReport({ title, procedureName }) {
  console.log('PendingByReport')

  const [results, setResults] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])

  useEffect(() => {
    getData(null, PENDING_BY_REPORT, 'pendingByReport', setResults, setGraphQLErrors, 'inputs', { procedureName: procedureName })
  }, [procedureName])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (!results) {
    return <Spinner />
  } else {
    let totalColumns = []
    let columnFormatters = []
    if (procedureName === 'pending_by_year' || procedureName === 'all_by_month_year') {
      for (let cols = 2; cols < results.columnHeadings.length + 1; cols++) {
        totalColumns.push({ columnNumber: cols, formatter: new Intl.NumberFormat().format })
      }
      for (let cols = 2; cols < results.columnHeadings.length + 1; cols++) {
        columnFormatters.push({ columnNumber: cols, formatter: new Intl.NumberFormat().format, align: 'right' })
      }
    } else {
      totalColumns = [
        { columnNumber: 2, formatter: new Intl.NumberFormat().format }
      ]
      columnFormatters = [
        { columnNumber: 2, formatter: new Intl.NumberFormat().format, align: 'right' },
      ]
    }
    const csvUrl = `${process.env.REACT_APP_SERVER}/csv/${getTenant()}/custom/BosSci/pendingByReport/${procedureName}.csv?inputs={"procedureName":"${procedureName}"}`
    const widths = ['0%', '100%', '0%']
    return (
      <div className="custom-scroll">
        <div style={{ textAlign: 'center', margin: '10px 0px' }}>
          <LargeRowHandler csvUrl={csvUrl} resultsLength={results.reportData.length} />
        </div>
        <Table bordered style={{backgroundColor: 'white', width: 'auto', margin: 'auto'}} >
          <ReportHeading title={title} parameterValues={ParameterValues(results)} showReportDate={false} widths={widths} />
          <tbody>
            <ColumnHeadings results={results} noNumberRow={true} />
            <ReportGrid results={results} columnFormatters={columnFormatters} doesNotHaveNumberRow={true} />
            <ReportTotalsRow reportData={results.reportData} totalColumns={totalColumns} totalColSpan={1} />
          </tbody>
        </Table>
      </div>
    )
  }
}
